import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=23a534ac&scoped=true"
import script from "./FormTask.vue?vue&type=script&lang=js"
export * from "./FormTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a534ac",
  null
  
)

export default component.exports